import Table from 'antd/es/table';
import { useStore } from 'effector-react';
import { Collapse } from 'antd';
import { $userInfo } from '../../models/authModel/index.js';

const status_colors = {
  active: '#05CD99',
  inactive: '#EE5D50',
};

// const dataSource = [
//   {
//     id: '1',
//     name: 'Рассмотрение споров в арбитраже в соответствии с законодательными актами Республики Казахстан.',
//     responsible: 'ЧУ «Арбитражный центр Атамекен»',
//     cost: 'В соответствии с решением Управляющего совета ЧУ «Арбитражный центр Атамекен»',
//   },
//   {
//     id: '2',
//     name: 'Предоставление информации с базы данных товаров, работ, услуг и их поставщиков.',
//     responsible: 'ТОО «ЦМЭР»',
//     cost: 'по подписке - 5 МРП/мес.',
//   },
//   {
//     id: '3',
//     name: 'Организация торгово-экономической миссии с выездом из РК.',
//     responsible: 'ТОО «ВПК»',
//     cost: 'от 16 МРП (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, или субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона «О Национальной палате предпринимателей РК «Атамекен» (далее- Закон). Стоимость услуг не включает расходы за рубежом.',
//   },
//   {
//     id: '4',
//     name: 'Оказание информационных, переводческих и консалтинговых услуг по вопросам внешнеэкономической деятельности.',
//     responsible: 'ТОО «ВПК»',
//     cost: '1.Переводческие услуги: - 3 МРП за 1 стр. документа Microsoft Word формата А4, шрифт не менее 14 Times New Roman / за 1 слайд Power Point; 2.Услуга визовой поддержки за одного человека: - для резидентов РК 8 МРП (дисконт 50% для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона); - для нерезидентов РК 15 МРП. Стоимость услуг не включает оплату визовых сборов/консульских расходов за выдачу виз. 3. Предоставление информации о зарубежной компании - 17 МРП (дисконт 50% для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '5',
//     name: 'Свидетельствование обстоятельств непреодолимой силы в соответствии с условиями внешнеторговых сделок и международных договоров Республики Казахстан, а также торговых и портовых обычаев, признанных в Республике Казахстан.',
//     responsible: 'ТОО «ВПК»',
//     cost: '1. За правовой анализ документов 15 МРП; 2. за свидетельствование обстоятельств непреодолимой силы (форс-мажор) и обстоятельств «Hardship»: 1) при сумме просроченного обязательства до 100 000 тенге включительно - стоимость за свидетельствование входит в стоимость правового анализа; 2) при сумме просроченного обязательства свыше 100 000 тенге - 1% от суммы просроченного (неисполненного) обязательства по договору (контракту), но не более 4 500 МРП. 3. Правовой анализ документов и свидетельствование обстоятельств непреодолимой силы (форс-мажор) и обстоятельств «Hardship» по заявлениям обществ людей с ограниченными возможностями, некоммерческих организаций учрежденных для обеспечения прав и законных интересов детей-воспитанников осуществляется на безвозмездной основе.',
//   },
//   {
//     id: '6',
//     name: 'Выступление гарантом и выдача документов о временном ввозе в соответствии с международными обязательствами Республики Казахстан.',
//     responsible: 'ТОО «ВПК»',
//     cost: '60 МРП за один сертификат о временном ввозе.',
//   },
//   {
//     id: '7',
//     name: 'Патронаж мероприятия.',
//     responsible: 'ТОО «ВПК»',
//     cost: '15 МРП за патронаж одного мероприятия.',
//   },
//   {
//     id: '8',
//     name: 'Организация семинаров, конференций, круглых столов.',
//     responsible: 'ТОО «ВПК»',
//     cost: '190 МРП за организацию семинара либо конференции, либо круглого стола (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона). Стоимость услуг не включает расходов по аренде помещений.',
//   },
//   {
//     id: '9',
//     name: 'Организация посещения казахстанских предприятий.',
//     responsible: 'ТОО «ВПК»',
//     cost: '15 МРП за организацию посещения одного казахстанского предприятия. Стоимость услуг не включает расходов по найму транспорта и проживания.',
//   },
//   {
//     id: '10',
//     name: 'Маркетинговые услуги по изучению рынка и популяризации продукта',
//     responsible: 'ТОО «ВПК»',
//     cost: '90 МРП (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '11',
//     name: 'Юридическая экспертиза документов, а также составление договоров, дополнительных соглашений к договорам, протоколов разногласий.',
//     responsible: 'ТОО «ВПК»',
//     cost: '1. 15 МРП за юридическую экспертизу одного документа (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона); 2. 15 МРП за составление одного договора/дополнительного соглашения/протокола разногласий (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '12',
//     name: 'Подготовка пакета документов для регистрации/перерегистрации юридического лица, индивидуального предпринимателя.',
//     responsible: 'ТОО «ВПК»',
//     cost: '35 МРП (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '13',
//     name: 'Содействие в регистрации товарных знаков.',
//     responsible: 'ТОО «ВПК»',
//     cost: '55 МРП за регистрацию одного товарного знака (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '14',
//     name: 'Разработка локальных нормативных актов и типовых (внутренних) документов организации.',
//     responsible: 'ТОО «ВПК»',
//     cost: '15 МРП за один документ (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '15',
//     name: 'Выдача справок об условиях ввоза и вывоза конкретного товара (по коду ТН ВЭД).',
//     responsible: 'ТОО «ВПК»',
//     cost: '15 МРП (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '16',
//     name: 'Оказание консультационных услуг по определению кода товара по ТН ВЭД и таможенной стоимости товара.',
//     responsible: 'ТОО «ВПК»',
//     cost: '15 МРП за один продукт (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '17',
//     name: 'Юридическое сопровождение деятельности участника внешнеэкономической деятельности по услугам определения кода товара по ТН ВЭД и таможенной стоимости товара в случае необходимости и обращения участника внешнеэкономической деятельности за защитой в суд.',
//     responsible: 'ТОО «ВПК»',
//     cost: '10% от оспариваемой в суде суммы, но не менее 121 МРП.',
//   },
//   {
//     id: '18',
//     name: 'Заключение договора поручительства в качестве обеспечения уплаты таможенных пошлин, налогов.',
//     responsible: 'ТОО «ВПК»',
//     cost: '30 МРП.',
//   },
//   {
//     id: '19',
//     name: 'Подготовка документов по предложениям участников внешнеэкономической деятельности по пересмотру ставок таможенных пошлин.',
//     responsible: 'ТОО «ВПК»',
//     cost: '100 МРП (дисконт до 50%* для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона).',
//   },
//   {
//     id: '20',
//     name: 'Организация торгово-экономической миссии в Казахстан для иностранных предпринимателей.',
//     responsible: '',
//     cost: 'Организационные сборы за одно предприятие: - 30 МРП для иностранных предпринимателей из стран-членов ОЭСР; - 15 МРП для иностранных предпринимателей не из стран-членов ОЭСР.',
//   },
//   {
//     id: '21',
//     name: 'Ведение реестра субъектов предпринимательства, участников внешнеэкономической деятельности, финансово-экономическое положение которых позволяет определить уровень их надежности как партнеров для предпринимательской деятельности, составленный по согласованию с указанными лицами.',
//     responsible: 'РПП',
//     cost: '1. 20 МРП (дисконт 50% для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона) – внесение в реестр; 2. 15 МРП (дисконт 50% для субъектов, не имеющих задолженность по оплате ОЧВ, субъектов, указанных в подпункте 1) пункта 2 статьи 29 Закона) – ведение реестра (ежегодно).',
//   },
//   {
//     id: '22',
//     name: 'Выдача сертификата о происхождении товара',
//     responsible: 'РПП',
//     cost: '3 МРП. Стоимость за заверение и копирование сертификатов о происхождении товаров: 200 тенге за копию и заверение одной страницы сертификата о происхождении товара.',
//   },
//   {
//     id: '23',
//     name: 'Услуги по обучению основам предпринимательства по проекту "Бастау Бизнес"',
//     responsible: 'НПП,РПП',
//     cost: 'На содержание 1-го слушателя проекта (при обучении не менее 30 000 слушателей): -при дистанционном обучении - в размере 52 510 тенге; -при очном обучении - в размере 76 537 тенге',
//   },
//   {
//     id: '24',
//     name: 'Регистрация экспортеров в информационных системах стран ввоза товара или внесение изменений в регистрационные данные экспортеров (в части перечня товаров)',
//     responsible: 'РПП',
//     cost: '3 МРП',
//   },
//   {
//     id: '25',
//     name: 'Услуги на базе реестра бизнес-партнеров и порядок их предоставления отечественным и зарубежным субъектам предпринимательства, государственным органам и иным лицам',
//     responsible: 'НПП',
//     cost: '1) Расширенный Отчет KYC (Know Your Customer) для авторизованных пользователей – Стоимость 300 тенге на пилотный период до 31.05.2022. С 01.06.2022 – 1000 тенге. Комиссионное вознаграждение для трансферагентов до 20% 2) Расширенный Отчет KYC (Know Your Customer) PRO для авторизованных пользователей – Стоимость 500 тенге на пилотный период до 31.05.2022. С 01.06.2022 – 1500 тенге. Комиссионное вознаграждение для трансферагентов до 20% 3) ИДН API (Индекс добросовестности налогоплательщика) – стоимость 300 тенге (договор) стоимость 10 тенге (транзакция) Комиссионное вознаграждение для трансферагентов до 20% 4) Индекс финансовой устойчивости – 500 тенге Комиссионное вознаграждение для трансферагентов до 20% 5) Индекс платежной дисциплины – 500 тенге Комиссионное вознаграждение для трансферагентов до 20% 6) Индекс деловой репутации – 500 тенге Комиссионное вознаграждение для трансферагентов до 20% 7) Сводный скоринговый индекс Atameken Business Information Services ABIS – 1000 тенге. Комиссионное вознаграждение для трансферагентов до 20%',
//   },
//   {
//     id: '26',
//     name: 'Перечень и стоимость платных услуг оказываемых Палатами предпринимателей городов Астаны, Шымкента Акмолинской, Восточно- Казахстанской и Карагандинской областей в рамках пилотного проекта по «Частичной коммерциализации услуг»    ',
//     responsible: 'РПП',
//     cost: 'Согласно приложению № 2 к Перечню и стоимости платных услуг,оказываемых Национальной палатой предпринимателей Республики Казахстан «Атамекен» (без учета НДС)',
//   },
// ];

const dataSource = {
  1: [
    {
      name: 'Рассмотрение споров в арбитраже',
      cost: 'По тарифам центра',
      responsible: 'Арбитражный центр «Атамекен»',
      key: '1-1',
    },
    {
      name: 'Юридическая экспертиза и составление договоров',
      cost: '15 МРП за документ',
      responsible: 'ТОО «ВПК»',
      key: '1-2',
    },
    {
      name: 'Свидетельствование форс-мажора',
      cost: 'от 15 МРП или 1% от суммы (макс. 4500 МРП)',
      responsible: 'ТОО «ВПК»',
      key: '1-3',
    },
    {
      name: 'Юридическое сопровождение ВЭД в суде',
      cost: '10% от суммы, но не менее 121 МРП',
      responsible: 'ТОО «ВПК»',
      key: '1-4',
    },
  ],
  2: [
    {
      name: 'Переводы и консалтинг по ВЭД',
      cost: 'от 3 до 17 МРП',
      responsible: 'ТОО «ВПК»',
      key: '2-1',
    },
    {
      name: 'Выдача документов о временном ввозе',
      cost: '60 МРП',
      responsible: 'ТОО «ВПК»',
      key: '2-2',
    },
    {
      name: 'Определение кода ТН ВЭД и таможенной стоимости',
      cost: '15 МРП',
      responsible: 'ТОО «ВПК»',
      key: '2-3',
    },
    {
      name: 'Подготовка предложений по пересмотру пошлин',
      cost: '100 МРП',
      responsible: 'ТОО «ВПК»',
      key: '2-4',
    },
    {
      name: 'Регистрация экспортеров в ИС стран-партнеров',
      cost: '3 МРП',
      responsible: 'РПП',
      key: '2-5',
    },
  ],
  3: [
    {
      name: 'Регистрация/перерегистрация ТОО, ИП',
      cost: '35 МРП',
      responsible: 'ТОО «ВПК»',
      key: '3-1',
    },
    {
      name: 'Разработка внутренних нормативных актов',
      cost: '15 МРП',
      responsible: 'ТОО «ВПК»',
      key: '3-2',
    },
    {
      name: 'Регистрация товарных знаков',
      cost: '55 МРП',
      responsible: 'ТОО «ВПК»',
      key: '3-3',
    },
    {
      name: 'Выдача справок по коду ТН ВЭД',
      cost: '15 МРП',
      responsible: 'ТОО «ВПК»',
      key: '3-4',
    },
  ],
  4: [
    {
      name: 'Миссии за рубеж для казахстанского бизнеса',
      cost: 'от 16 МРП',
      responsible: 'ТОО «ВПК»',
      key: '4-1',
    },
    {
      name: 'Патронаж мероприятий',
      cost: '15 МРП',
      responsible: 'ТОО «ВПК»',
      key: '4-2',
    },
    {
      name: 'Организация визитов на предприятия РК',
      cost: '15 МРП',
      responsible: 'ТОО «ВПК»',
      key: '4-3',
    },
    {
      name: 'Миссии в Казахстан для иностранных предпринимателей',
      cost: 'от 15 до 30 МРП',
      responsible: 'ТОО «ВПК»',
      key: '4-4',
    },
  ],
  5: [
    {
      name: 'База данных поставщиков товаров и услуг',
      cost: '5 МРП/мес',
      responsible: 'ЦМЭР',
      key: '5-1',
    },
    {
      name: 'Индекс добросовестности, платежная дисциплина и др. KYC-сервисы',
      cost: 'от 300 до 1500 тенге',
      responsible: 'НПП',
      key: '5-2',
    },
    {
      name: 'Реестр субъектов ВЭД и надежных партнеров',
      cost: 'от 15 до 20 МРП',
      responsible: 'РПП',
      key: '5-3',
    },
  ],
  6: [
    {
      name: 'Обучение по проекту «Бастау Бизнес»',
      cost: '52 510 тг (дистанционно), 76 537 тг (очно)',
      responsible: 'НПП / РПП ',
      key: '6-1',
    },
    {
      name: 'Организация семинаров, круглых столов',
      cost: '190 МРП',
      responsible: 'ВПК',
      key: '6-2',
    },
    {
      name: 'Маркетинговые исследования и анализ рынка',
      cost: '90 МРП',
      responsible: 'ВПК',
      key: '6-3',
    },
  ],
};

const columns = [
  {
    title: 'Наименование',
    key: 'name',
    dataIndex: 'name',
  },
  {
    title: 'Стоимость',
    key: 'cost',
    dataIndex: 'cost',
  },
  {
    title: 'Исполнитель',
    key: 'responsible',
    dataIndex: 'responsible',
  },
];

const collapses = [
  {
    label: 'Арбитраж и юридическая поддержка',
    key: '1',
    children: (
      <Table columns={columns} dataSource={dataSource[1]} pagination={false} />
    ),
  },
  {
    label: 'Внешнеэкономическая деятельность (ВЭД)',
    key: '2',
    children: (
      <Table columns={columns} dataSource={dataSource[2]} pagination={false} />
    ),
  },
  {
    label: 'Регистрация и сопровождение бизнеса',
    key: '3',
    children: (
      <Table columns={columns} dataSource={dataSource[3]} pagination={false} />
    ),
  },
  {
    label: 'Торгово-экономические миссии и мероприятия',
    key: '4',
    children: (
      <Table columns={columns} dataSource={dataSource[4]} pagination={false} />
    ),
  },
  {
    label: 'Аналитика и цифровые сервисы',
    key: '5',
    children: (
      <Table columns={columns} dataSource={dataSource[5]} pagination={false} />
    ),
  },
  {
    label: 'Образование и развитие бизнеса',
    key: '6',
    children: (
      <Table columns={columns} dataSource={dataSource[6]} pagination={false} />
    ),
  },
];

function PaidServicesTable() {
  const userInfo = useStore($userInfo);
  // const columns = [
  //   {
  //     title: '№',
  //     dataIndex: 'id',
  //     key: 'paid_id',
  //   },
  //   {
  //     title: 'Виды платных услуг',
  //     dataIndex: 'name',
  //     key: 'paid_name',
  //     render: (name, record) => {
  //       return {
  //         props: {
  //           style: {
  //             background: userInfo.mmf_payed
  //               ? status_colors.active
  //               : status_colors.inactive,
  //           },
  //         },
  //         children: <div>{name}</div>,
  //       };
  //     },
  //   },
  //   {
  //     title: 'Исполнитель услуги (юридическое лицо, входящее в систему НПП)',
  //     dataIndex: 'responsible',
  //     key: 'paid_responsible',
  //   },
  //   {
  //     title:
  //       'Стоимость услуг\n' +
  //       '* размер дисконта определяется решением исполнительного органа юридического лица, входящего в систему НПП',
  //     dataIndex: 'cost',
  //     key: 'paid_cost',
  //   },
  // ];

  // return <Table columns={columns} dataSource={dataSource} pagination={false} />;

  return <Collapse items={collapses} />;
}

export default PaidServicesTable;
